import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Footer,
  Hero,
  PropertyOverview,
  CalloutBand,
  FloorplanTypes,
  AmenitiesHighlight,
  GalleryHighlight,
  ImageBanner,
  NeighborhoodSplit,
  ContactCTA,
  PageHero,
  FloorplansList,
  AmenitiesList,
  Gallery,
  VirtualTours,
  NeighborhoodGuide,
  ContactInfo,
  StoryRows,
  LegalContent,
  SitemapContent,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Footer,
  Hero,
  PropertyOverview,
  CalloutBand,
  FloorplanTypes,
  AmenitiesHighlight,
  GalleryHighlight,
  ImageBanner,
  NeighborhoodSplit,
  ContactCTA,
  PageHero,
  FloorplansList,
  AmenitiesList,
  Gallery,
  VirtualTours,
  NeighborhoodGuide,
  ContactInfo,
  StoryRows,
  LegalContent,
  SitemapContent,
};

export default registry;
